import { render, staticRenderFns } from "./ShopTab.vue?vue&type=template&id=0e5e5006"
import script from "./ShopTab.vue?vue&type=script&lang=js"
export * from "./ShopTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports